// @ts-nocheck
import { errorViewRoute } from "@/router";
import { createSlice } from "@reduxjs/toolkit";
import { getSearchParam } from "@utils/index";
export const initInfo =
  isJSONString(indexPageInitDataFromServer) &&
  isEnableParse(indexPageInitDataFromServer) &&
  !isEmptyType(JSON.parse(indexPageInitDataFromServer)?.data)
    ? JSON.parse(indexPageInitDataFromServer)?.data
    : {};
if (!isEmptyType(initInfo)) {
  initInfo.info = initInfo.baseInfo;
  delete initInfo.baseInfo;
}
const initialState: any = {
  homeState: initInfo,
  /* homeState: {}, */
};
export const homeSlice: any = createSlice({
  name: "homeSpace",
  initialState,
  reducers: {
    setHomeState(state, { type, payload }: any) {
      switch (type) {
        case "homeSpace/setHomeState":
          state.homeState = {
            ...state.homeState,
            ...payload,
          };
          break;
      }
    },
  },
});
const { setHomeState } = homeSlice.actions;
const fetchWeatherInfoByKeyId = async (dispatch: any, params: any = {}) => {
  return new Promise(async (resolve, reject) => {
    try {
      // @ts-ignore
      const position = window?.globalState?.position ?? {};
      const condition =
        (isEmptyType(params.keyId) &&
          isEmptyType(getSearchParam("latitude")) &&
          isEmptyType(getSearchParam("longitude")) &&
          ((isEmptyType(position?.latitude) && isEmptyType(position?.longitude)) ||
            (!isEmptyType(position?.latitude) &&
              position.latitude * 1 === 0 &&
              !isEmptyType(position?.longitude) &&
              position.longitude * 1 === 0))) ||
        ((isEmptyType(position) ||
          (!isEmptyType(position?.latitude) &&
            position.latitude * 1 === 0 &&
            !isEmptyType(position?.longitude) &&
            position.longitude * 1 === 0)) &&
          !isEmptyType(getSearchParam("latitude")) &&
          !isEmptyType(getSearchParam("longitude")) &&
          !isEmptyType(getSearchParam("keyId")));
      if (condition) {
        params.keyId = getSearchParam("keyId");
      }
      const resData: any = await homeApi.queryHome(params);
      LocalStorage.setItem("awsCon", resData.data?.awsCon);
      resData.data.info = resData.data?.baseInfo ?? resData.data?.info;
      delete resData.data.baseInfo;
      LocalStorage.setItem("info", resData.data.info);
      dispatch(setHomeState(resData.data));
      resolve(resData.data);
    } catch (error: any) {
      window.location.hash = errorViewRoute.path + `?errorMessage=${encodeURIComponent(error.message)}`;
      reject(error);
    }
  });
};
export { setHomeState, fetchWeatherInfoByKeyId };
export const homeStateSelector = (state: any) => state.homeReducer.homeState;
export default homeSlice.reducer;
